import { SEARCHSESSION_FAIL, SEARCHSESSION_SUCCESS } from '../actionTypes';

const initialState = {
    user: null
};

const searchSessionReducer = (state = initialState, action) => {
    switch (action.type) {
        case SEARCHSESSION_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case SEARCHSESSION_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default searchSessionReducer;
